(function () {
  function normalize(text) {
    return (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function initPanel(panel) {
    if (panel.hasAttribute('data-brand-ready')) return;
    panel.setAttribute('data-brand-ready', '');

    var colsDesktop = parseInt(panel.getAttribute('data-cols'), 10) || 4;
    var colsMobile = parseInt(panel.getAttribute('data-cols-mobile'), 10) || 2;
    var rowsDesktop = parseInt(panel.getAttribute('data-rows'), 10) || 2;
    var rowsMobile = parseInt(panel.getAttribute('data-rows-mobile'), 10) || rowsDesktop;

    // mêmes seuils que le CSS de la section : 768, 1024 et 1280 px
    function perRow() {
      var width = window.innerWidth;
      if (width >= 1280) return colsDesktop;
      if (width >= 1024) return Math.min(4, colsDesktop);
      if (width >= 768) return Math.min(3, colsDesktop);
      return colsMobile;
    }

    function currentLimit() {
      return perRow() * (window.innerWidth >= 768 ? rowsDesktop : rowsMobile);
    }
    var grid = panel.querySelector('.card-grid');
    var cards = Array.prototype.slice.call(panel.querySelectorAll('.card-grid > .card'));
    // Mobile : les cartes défilent sur une seule rangée (12 au plus), « Voir tout » ouvre la grille complète.
    var RAIL_MAX = parseInt(panel.getAttribute('data-rail-max'), 10) || 12;
    var more = panel.querySelector('[data-brand-more]');
    var toggle = panel.querySelector('[data-brand-toggle]');
    var input = panel.querySelector('[data-brand-search]');
    var empty = panel.querySelector('[data-brand-empty]');
    var expanded = false;

    var labels = cards.map(function (card) {
      var link = card.querySelector('a');
      return normalize(link ? link.getAttribute('aria-label') : card.textContent);
    });

    function render() {
      var limit = currentLimit();
      var query = input ? normalize(input.value.trim()) : '';
      var shown = 0;
      var rail = window.innerWidth < 768 && query === '' && !expanded;
      var visibleLimit = rail ? Math.max(limit, RAIL_MAX) : limit;
      if (grid) grid.classList.toggle('featured-brand__grid--rail', rail);

      cards.forEach(function (card, index) {
        var matches = !query || labels[index].indexOf(query) !== -1;
        var visible = matches && (query !== '' || expanded || index < visibleLimit);
        card.classList.toggle('featured-brand__card-hidden', !visible);
        if (visible) shown += 1;
      });

      if (more) more.hidden = query !== '' || cards.length <= limit;
      if (empty) empty.hidden = shown > 0;

      if (toggle) {
        var label = toggle.querySelector('.btn-text');
        if (label) {
          label.textContent = expanded
            ? toggle.getAttribute('data-less')
            : toggle.getAttribute('data-more') + ' (' + cards.length + ')';
        }
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        expanded = !expanded;
        render();
      });
    }
    if (input) {
      input.addEventListener('input', render);
    }
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(render, 120);
    });

    render();
  }

  document.querySelectorAll('[data-featured-brand] [data-brand-panel]').forEach(initPanel);
})();
